import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import {jwtDecode} from 'jwt-decode';

const Callback = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const handleCallback = async () => {
      const query = new URLSearchParams(window.location.search);
      const code = query.get('code');

      if (!code) {
        //console.warn('[Callback] No code found in URL. Redirecting to home.');
        navigate('/');
        return;
      }

      const {
        REACT_APP_COGNITO_DOMAIN,
        REACT_APP_COGNITO_CLIENT_ID,
        REACT_APP_COGNITO_CLIENT_SECRET,
        REACT_APP_COGNITO_REDIRECT_URI,
      } = process.env;

      const tokenUrl = `${REACT_APP_COGNITO_DOMAIN}/oauth2/token`;

      const params = new URLSearchParams();
      params.append('grant_type', 'authorization_code');
      params.append('client_id', REACT_APP_COGNITO_CLIENT_ID);
      params.append('client_secret', REACT_APP_COGNITO_CLIENT_SECRET);
      params.append('code', code);
      params.append('redirect_uri', REACT_APP_COGNITO_REDIRECT_URI);

      try {
        const response = await fetch(tokenUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params.toString(),
        });

        if (!response.ok) {
          throw new Error(`Token exchange failed: ${await response.text()}`);
        }

        const data = await response.json();

        // Decode the id_token to extract user information
        const user = jwtDecode(data.id_token);

        // Login the user with tokens and user info
        login({
          tokens: {
            id_token: data.id_token,
            access_token: data.access_token,
            refresh_token: data.refresh_token,
          },
          user,
        });

        navigate('/dash'); // Redirect to a protected route
      } catch (error) {
        //console.error('[Callback] Error during token exchange:', error);
        navigate('/');
      }
    };

    handleCallback();
  }, [login, navigate]);

  return <div>Signing in, please wait...</div>;
};

export default Callback;